<template>
  <div>
    <div class="d-flex flex-wrap">
      <div class="col-md-12">
        <h4 class="mt-4 mb-3 title-custom">
          Cambios solicitados: Diminución de coberturas
        </h4>
      </div>
    </div>

    <div class="d-flex flex-wrap">
      <div class="col-md-12">
        <ul class="nav nav-tabs justify-content-end" id="myTab" role="tablist">
          <li class="nav-item" role="presentation">
            <button
              class="nav-link"
              id="home-tab"
              data-bs-toggle="tab"
              data-bs-target="#home-tab-pane"
              type="button"
              role="tab"
              aria-controls="home-tab-pane"
              aria-selected="false"
            >
              Vehículo
            </button>
          </li>
          <li class="nav-item" role="presentation">
            <button
              class="nav-link active"
              id="profile-tab"
              data-bs-toggle="tab"
              data-bs-target="#profile-tab-pane"
              type="button"
              role="tab"
              aria-controls="profile-tab-pane"
              aria-selected="true"
            >
              Coberturas
            </button>
          </li>
          <li class="nav-item" role="presentation">
            <button
              class="nav-link"
              id="contact-tab"
              data-bs-toggle="tab"
              data-bs-target="#contact-tab-pane"
              type="button"
              role="tab"
              aria-controls="contact-tab-pane"
              aria-selected="false"
            >
              Mensajes
            </button>
          </li>
        </ul>
        <div class="tab-content" id="myTabContent">
          <div
            class="tab-pane fade"
            id="home-tab-pane"
            role="tabpanel"
            aria-labelledby="home-tab"
            tabindex="0"
          >
            <h4 class="title-custom mt-4">Vehículo asegurado</h4>

            <div class="row mt-4">
              <div class="col-md-3">
                <p>
                  Kilometraje:
                  <span class="label-custom-bold">23,000 KM</span>
                </p>
              </div>
              <div class="col-md-9">
                <p>
                  Descripción:
                  <span class="label-custom-bold"
                    >RENAULT KWID BITONO L3 1.0L 66 STD 05 05 ABS AC BAVE MP3
                    TELA BT DT</span
                  >
                </p>
              </div>
              <div class="col-md-3">
                <p>
                  Marca:
                  <span class="label-custom-bold">RENAULT</span>
                </p>
              </div>
              <div class="col-md-3">
                <p>
                  Modelo:
                  <span class="label-custom-bold">2022</span>
                </p>
              </div>
              <div class="col-md-3">
                <p>
                  Submarca:
                  <span class="label-custom-bold">KWID</span>
                </p>
              </div>
              <div class="col-md-3">
                <p>
                  Numero de Serie:
                  <span class="label-custom-bold">3CZRE3858AG042709</span>
                </p>
              </div>
              <div class="col-md-6">
                <p>
                  Numero de identificación vehicular (NIV):
                  <span class="label-custom-bold"></span>
                </p>
              </div>
              <div class="col-md-6">
                <p>
                  Número de motor:
                  <span class="label-custom-bold">3CZRE3858AG042709</span>
                </p>
              </div>
              <div class="col-md-12">
                <p>
                  Placas:
                  <span class="label-custom-bold">PRE26AA</span>
                </p>
              </div>
            </div>
          </div>
          <div
            class="tab-pane fade show active"
            id="profile-tab-pane"
            role="tabpanel"
            aria-labelledby="profile-tab"
            tabindex="0"
          >
            <h4 class="title-custom mt-4">Coberturas a modificar</h4>

            <div class="row mt-4">
              <div class="col-md-12">
                <table class="table table-borderless">
                  <thead>
                    <tr>
                      <th>Paquete</th>
                      <th>Coberturas</th>
                      <th>Suma asegurada</th>
                      <th>Deducible</th>
                      <th>Primas</th>
                      <th>Agregar</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(cob, i) in datosPoliza.INCISO[0].COBERTURAS"
                      :key="i"
                    >
                      <td>
                        <span v-if="i === 0">{{ cob.PAQUETE }}</span>
                      </td>
                      <td>{{ cob.DESCRIPCION }}</td>
                      <td>{{ cob.SUMAASEGURADA }}</td>
                      <td>
                        {{ cob.DEDUCIBLE !== "" ? cob.DEDUCIBLE : "N/A" }}
                      </td>
                      <td>${{ cob.PRIMA }}</td>
                      <td>
                        <input type="checkbox" checked />
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

            <h4 class="title-custom mt-4">Coberturas personalizadas</h4>

            <div class="row mt-4">
              <div class="col-md-12">
                <table class="table table-borderless">
                  <thead>
                    <tr>
                      <th></th>
                      <th>Coberturas</th>
                      <th>Suma asegurada</th>
                      <th>Deducible</th>
                      <th>Primas</th>
                      <th>Agregar</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(cob, i) in cobsExtras" :key="i">
                      <td></td>
                      <td>{{ cob.DESCRIPCIONCOBERTURA }}</td>
                      <td>
                        <div v-if="cob.SUMAS.length > 1">
                          <select
                            class="form-control"
                            v-model="cob.SUMADEFAULT"
                          >
                            <option
                              v-for="(sum, ind) in cob.SUMAS"
                              :key="ind"
                              :value="sum.VALOR"
                            >
                              {{ sum.DESCRIPCION }}
                            </option>
                          </select>
                        </div>
                        <div v-else>
                          {{ cob.SUMAS[0].DESCRIPCION }}
                        </div>
                      </td>
                      <td>
                        <div v-if="cob.DEDUCIBLES.length > 0">
                          <select
                            class="form-control"
                            v-model="cob.DEDUDEFAULT"
                          >
                            <option
                              v-for="(ded, ind) in cob.DEDUCIBLES"
                              :key="ind"
                              :value="ded.VALOR"
                            >
                              {{ ded.DESCRIPCION }}
                            </option>
                          </select>
                        </div>
                        <div v-else>{{ cob.DEDUDEFAULT }}</div>
                      </td>
                      <td>${{ cob.PRIMA }}</td>
                      <td>
                        <input type="checkbox" />
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

            <h4 class="title-custom mt-4">Asistencias</h4>

            <div class="row mt-4">
              <div class="col-md-12">
                <table class="table table-borderless">
                  <thead>
                    <tr>
                      <th></th>
                      <th>Coberturas</th>
                      <th>Suma asegurada</th>
                      <th>Deducible</th>
                      <th>Primas</th>
                      <th>Agregar</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(cob, i) in asistencias" :key="i">
                      <td></td>
                      <td>{{ cob.DESCRIPCIONCOBERTURA }}</td>
                      <td>
                        <div v-if="cob.SUMAS.length > 1">
                          <select
                            class="form-control"
                            v-model="cob.SUMADEFAULT"
                          >
                            <option
                              v-for="(sum, ind) in cob.SUMAS"
                              :key="ind"
                              :value="sum.VALOR"
                            >
                              {{ sum.DESCRIPCION }}
                            </option>
                          </select>
                        </div>
                        <div v-else>
                          {{ cob.SUMAS[0].DESCRIPCION }}
                        </div>
                      </td>
                      <td>
                        <div v-if="cob.DEDUCIBLES.length > 0">
                          <select
                            class="form-control"
                            v-model="cob.DEDUDEFAULT"
                          >
                            <option
                              v-for="(ded, ind) in cob.DEDUCIBLES"
                              :key="ind"
                              :value="ded.VALOR"
                            >
                              {{ ded.DESCRIPCION }}
                            </option>
                          </select>
                        </div>
                        <div v-else>{{ cob.DEDUDEFAULT }}</div>
                      </td>
                      <td>${{ cob.PRIMA }}</td>
                      <td>
                        <input type="checkbox" />
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

            <hr />

            <h4 class="title-custom mt-4">Forma de Pago</h4>

            <div class="row mt-4">
              <div class="col-md-6">
                <div class="form-group row d-flex align-items-center">
                  <div class="col-md-3">
                    <label>Forma de Pago</label>
                  </div>
                  <div class="col-md-9">
                    <select class="form-control">
                      <option value="">ANUAL</option>
                    </select>
                  </div>
                </div>
                <div class="form-group row d-flex align-items-center">
                  <div class="col-md-3">
                    <label>Periodo de pago</label>
                  </div>
                  <div class="col-md-9">
                    <select class="form-control">
                      <option value="">CONTADO</option>
                    </select>
                  </div>
                </div>
                <div class="form-group row d-flex align-items-center">
                  <div class="col-md-3">
                    <label>Paquete</label>
                  </div>
                  <div class="col-md-9">
                    <label>Premium</label>
                  </div>
                </div>
                <div class="form-group row d-flex align-items-center">
                  <div class="col-md-3">
                    <label>Inicio de Vigencia</label>
                  </div>
                  <div class="col-md-9">
                    <label>dd/mm/aaaa</label>
                  </div>
                </div>
                <div class="form-group row d-flex align-items-center">
                  <div class="col-md-3">
                    <label>Fin de Vigencia</label>
                  </div>
                  <div class="col-md-9">
                    <label>dd/mm/aaaa</label>
                  </div>
                </div>
                <div class="form-group row d-flex align-items-center">
                  <div class="col-md-3">
                    <label>Duración (días)</label>
                  </div>
                  <div class="col-md-9">
                    <label>0</label>
                  </div>
                </div>
                <div class="form-group row d-flex align-items-center">
                  <div class="col-md-3">
                    <label>Valor</label>
                  </div>
                  <div class="col-md-9">
                    <label>$0.00</label>
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group row d-flex align-items-center">
                  <div class="col-md-3">
                    <label>Primer recibo</label>
                  </div>
                  <div class="col-md-9">
                    <label>$0.00</label>
                  </div>
                </div>
                <div class="form-group row d-flex align-items-center">
                  <div class="col-md-3">
                    <label>Subsecuentes</label>
                  </div>
                  <div class="col-md-9">
                    <label>$0.00</label>
                  </div>
                </div>
              </div>
            </div>

            <h4 class="title-custom mt-4">Vehículo asegurado</h4>

            <div class="row mt-4">
              <div class="col-md-3">
                <p>
                  Kilometraje:
                  <span class="label-custom-bold">{{
                    datosPoliza.INCISO[0].KILOMETRAJE
                  }}</span>
                </p>
              </div>
              <div class="col-md-9">
                <p>
                  Descripción:
                  <span class="label-custom-bold">{{
                    datosPoliza.INCISO[0].VEHICULO
                  }}</span>
                </p>
              </div>
              <div class="col-md-3">
                <p>
                  Marca:
                  <span class="label-custom-bold">{{
                    datosPoliza.INCISO[0].MARCA
                  }}</span>
                </p>
              </div>
              <div class="col-md-3">
                <p>
                  Modelo:
                  <span class="label-custom-bold">{{
                    datosPoliza.INCISO[0].MODELO
                  }}</span>
                </p>
              </div>
              <div class="col-md-3">
                <p>
                  Submarca:
                  <span class="label-custom-bold">{{
                    datosPoliza.INCISO[0].SUBMARCA
                  }}</span>
                </p>
              </div>
              <div class="col-md-3">
                <p>
                  Numero de Serie:
                  <span class="label-custom-bold">{{
                    datosPoliza.INCISO[0].SERIE
                  }}</span>
                </p>
              </div>
              <div class="col-md-6">
                <p>
                  Numero de identificación vehicular (NIV):
                  <span class="label-custom-bold"></span>
                </p>
              </div>
              <div class="col-md-6">
                <p>
                  Número de motor:
                  <span class="label-custom-bold">{{
                    datosPoliza.INCISO[0].MOTOR
                  }}</span>
                </p>
              </div>
              <div class="col-md-12">
                <p>
                  Placas:
                  <span class="label-custom-bold">{{
                    datosPoliza.INCISO[0].PLACA
                  }}</span>
                </p>
              </div>
            </div>

            <div
              class="row mt-4 pt-3"
              style="background-color: gainsboro !important"
            >
              <div class="col-md-6">
                <p>Prima neta:</p>
                <p>Recargo por pago fraccionado:</p>
                <p>Gastos de expedición:</p>
                <p>Subtotal:</p>
              </div>
              <div class="col-md-6">
                <p>I.V.A:</p>
                <p>Articulo 101:</p>
                <p>I.V.A. Articulo 101:</p>
                <p><span style="color: black !important">TOTAL:</span></p>
              </div>
            </div>

            <div class="row mt-4">
              <div class="col-md-12 d-flex justify-content-end">
                <button class="btn btn-primary btn-rounded mr-2">
                  Cotizar
                </button>
                <button class="btn btn-primary btn-rounded mr-2">Cerrar</button>
              </div>
            </div>
          </div>
          <div
            class="tab-pane fade"
            id="contact-tab-pane"
            role="tabpanel"
            aria-labelledby="contact-tab"
            tabindex="0"
          >
            <div class="row mt-4">
              <div class="col-md-8">
                <p>Mensaje de Suscripción:</p>
                <p>Se envía cotización.</p>
              </div>
              <div class="col-md-4">
                <p>Fecha</p>
                <p>24/08/2022</p>
              </div>
              <div class="col-md-12 mt-3">
                <textarea class="form-control"></textarea>
              </div>
              <div class="col-md-12 mt-4">
                <label
                  >Adjunta tus archivos aquí (formato .pdf)
                  <input type="file" class="ml-2"
                /></label>
              </div>
              <div class="col-md-12 mt-4 d-flex justify-content-end">
                <button class="btn btn-primary btn-rounded">Enviar</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    datosPoliza: Object,
    altaFolioInnova: Function,
  },
  data() {
    return {
      cobsExtras: this.filterTypeCobs(
        this.datosPoliza.INCISO[0].COBERTURASFALTANTES,
        3
      ),
      asistencias: this.filterTypeCobs(
        this.datosPoliza.INCISO[0].COBERTURASFALTANTES,
        2
      ),
    };
  },
  methods: {
    filterTypeCobs(cobs, type) {
      return cobs.filter((cob) => cob.TIPO === type);
    },
  },
};
</script>